import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPizzaSlice, faFire, faListUl } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '../../store/useSettingsStore';

const NAV_ITEMS = [
  { mode: 'menu',   key: 'menu',   icon: faPizzaSlice },
  { mode: 'orders', key: 'orders', icon: faListUl },
  { mode: 'baker',  key: 'baker',  icon: faFire },
];

function NavTabs() {
  const { t } = useTranslation();
  const mode = useSettingsStore((state) => state.mode);
  const setMode = useSettingsStore((state) => state.setMode);

  return (
    <nav className="flex items-stretch" aria-label={t('nav.aria')}>
      {NAV_ITEMS.map(({ mode: m, key, icon }) => {
        const active = mode === m;
        const label = t(`nav.${key}`);
        return (
          <button
            key={m}
            onClick={() => setMode(m)}
            className={[
              'relative flex min-h-12 items-center gap-1.5 px-3 py-3.5 text-sm font-medium transition-colors',
              'sm:px-4',
              active
                ? 'text-[color:var(--app-text)]'
                : 'text-[color:var(--app-muted)] hover:text-[color:var(--app-text)]',
            ].join(' ')}
          >
            <FontAwesomeIcon icon={icon} className="text-sm" />
            <span className={active ? '' : 'hidden sm:inline'}>{label}</span>
            {active && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 rounded-full bg-emerald-500" />
            )}
          </button>
        );
      })}
    </nav>
  );
}

export default NavTabs;